<template>
  <b-modal
    id="confirm-cancel-order"
    :no-close-on-backdrop="true"
    :hide-header="true"
    size="sm"
    centered
    footer-class="border-top-0 d-flex justify-content-center py-4"
    body-class="pt-4 text-center pb-0"
    dialog-class="mx-auto"
    @hidden="initCancelAttempt"
  >
    <img
      src="@/assets/images/ic-confirm-warning.svg"
      alt="Confirm Cancel Order"
      class="img-fluid mb-3"
    />
    <p class="text-center mb-0">
      <template v-if="cancelAttempt.status">{{
        cancelAttempt.message
      }}</template>
      <template v-else>Are you sure you want to cancel your order?</template>
    </p>
    <template slot="modal-footer">
      <template v-if="!cancelAttempt.status">
        <b-button
          id="yes"
          class="bg-transparent shadow-none border-0 w-100 text-uppercase"
          pill
          :disabled="isCancellingOrder"
          @click="cancel"
        >
          {{ `${isCancellingOrder ? "Cancelling..." : "Yes"}` }}
        </b-button>
        <b-button
          variant="primary"
          pill
          class="border-0 w-100 text-uppercase"
          :style="{
            backgroundColor:
              webDesign && webDesign.design
                ? `${webDesign.design.main_color} !important`
                : null,
            color:
              webDesign && webDesign.design
                ? `${webDesign.design.button_text_color} !important`
                : null
          }"
          :disabled="isCancellingOrder"
          @click="$root.$emit('bv::hide::modal', 'confirm-cancel-order')"
        >
          No
        </b-button>
      </template>
      <template v-else>
        <b-button
          variant="primary"
          pill
          class="border-0 w-100 text-uppercase"
          :style="{
            backgroundColor:
              webDesign && webDesign.design
                ? `${webDesign.design.main_color} !important`
                : null,
            color:
              webDesign && webDesign.design
                ? `${webDesign.design.button_text_color} !important`
                : null
          }"
          @click="$root.$emit('bv::hide::modal', 'confirm-cancel-order')"
        >
          Okay
        </b-button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "ConfirmCancelOrderModal",
  props: ["orderId"],
  data() {
    return {
      cancelAttempt: {
        status: 0,
        message: null
      }
    };
  },
  computed: {
    ...mapGetters("estore", [
      "isCancellingOrder",
      "errors",
      "cancelledOrderMsg"
    ]),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken
    })
  },
  methods: {
    ...mapActions("estore", ["cancelOrder"]),
    initCancelAttempt() {
      this.cancelAttempt.status = 0;
      this.cancelAttempt.message = null;
    },
    async cancel() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          order_uuid: this.orderId
        }
      };
      await this.cancelOrder(request).then(response => {
        if (
          (this.errors === null || Object.keys(this.errors).length === 0) &&
          response.cancel_success
        ) {
          this.$root.$emit("bv::hide::modal", "confirm-cancel-order");
          this.$root.$emit("bv::show::modal", "cancel-order-success");
          this.$router.push({ name: "Orders" });
        } else if (!response.cancel_success) {
          this.cancelAttempt.status = 1;
          this.cancelAttempt.message = this.cancelledOrderMsg;
        }
      });
    }
  }
};
</script>

<style lang="scss">
#confirm-cancel-order {
  .modal-dialog {
    max-width: 474px !important;
  }
  .modal-footer {
    .btn {
      max-width: 150px;
      height: 50px;
      &#yes {
        color: #68737d !important;
      }
    }
  }
}
</style>
